import { render, staticRenderFns } from "./UserProvincePage.vue?vue&type=template&id=1ac44d89&scoped=true"
import script from "./UserProvincePage.vue?vue&type=script&lang=js"
export * from "./UserProvincePage.vue?vue&type=script&lang=js"
import style0 from "./UserProvincePage.vue?vue&type=style&index=0&id=1ac44d89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac44d89",
  null
  
)

export default component.exports